import { type Widget } from "@repo/api";

export const useAvailableWidgets = (
  widgets: Widget[],
  enableQuotation: boolean,
  enableSalesforce: boolean
) => {
  return widgets.filter((widget) => {
    if (widget.widgetType === "QUOTATIONS") {
      return enableQuotation;
    }

    if (
      widget.widgetType === "INSTALLATION_QUOTATIONS" ||
      widget.widgetType === "WORK_ORDERS"
    ) {
      return enableSalesforce;
    }

    return true;
  });
};

export const groupWidgets = (widgets: Widget[]) => {
  return widgets.reduce(
    (acc, widget) => {
      if (!acc[widget.category]) {
        acc[widget.category] = [];
      }

      acc[widget.category].push(widget);
      return acc;
    },
    {} as Record<string, Widget[]>
  );
};
